import { call, put, takeLatest } from 'redux-saga/effects';
import { authApiClient } from '../../utils/axios';
import { fetchOrgFailure, fetchOrgRequest, fetchOrgSuccess } from './orgSlice';

function* fetchOrg() {
  try {
    const response = yield call(authApiClient.get, `/organization`);
    yield put(fetchOrgSuccess(response.data));
  } catch (error) {
    yield put(fetchOrgFailure(error.response?.data?.errors?.message || 'Login failed'));
  }
}

export default function* orgSaga() {
  yield takeLatest(fetchOrgRequest.type, fetchOrg);
}
